import i18n from 'commons/libs/i18n'
import { Card, DownloadLink } from 'components'

import * as S from './styles'

export const ModelSpreadsheetUrl = `${process.env.REACT_APP_DOWNLOAD_FILES_BASE_URL}/modelo_novo_upload_de_planilhas.xlsx`

export const MaterialInsertCard = () => {
  return (
    <Card>
      <S.CardMaterialInsertContent>
        <S.TitleCardMaterialInsert>
          <span id="MaterialsInsertTitle">
            {i18n.t('screens.sampleOrder.materialsInsertTitle')}
          </span>
          <span id="MaterialsInsertSubtitle">
            {i18n.t('screens.sampleOrder.materialsInsertSubtitle')}
          </span>
        </S.TitleCardMaterialInsert>

        <DownloadLink
          content={i18n.t('common.downloadTemplateSpreadsheet')}
          options={[
            {
              label: i18n.t('common.templateSpreadsheetLabel'),
              url: ModelSpreadsheetUrl,
            },
          ]}
        />
      </S.CardMaterialInsertContent>
    </Card>
  )
}
